module.exports = __webpack_public_path__ + "img/Weilin QR code quick recognition software.eb2b5dcf.jpg";